import { createAsyncThunk } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

/**
 * GET /chat-room/rooms/search?search=&page=&limit=
 */
export const SearchChatRoomsApi = createAsyncThunk(
  'chat-room/rooms/search',
  async ({ search = '', page = 1, limit = 10 }, { getState, rejectWithValue }) => {
    const { loginToken } = getState();
    const authToken = loginToken?.response?.token;
    try {
      const params = new URLSearchParams();
      params.set('search', String(search).trim());
      params.set('page', String(page));
      params.set('limit', String(limit));

      const response = await fetch(
        `${ROOT_URL}/chat-room/rooms/search?${params.toString()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error?.response || error?.message || error);
    }
  },
);
